export function NextArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={40}
      height={40}
      x={0}
      y={0}
      viewBox="0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <g data-name="Layer 2">
          <g data-name="Layer 1">
            <g data-name={2}>
              <path
                fill="currentcolor"
                d="m200.56 395.87-32.95-32.95a5.56 5.56 0 0 1 0-7.86l95.16-95.13a5.56 5.56 0 0 0 0-7.86l-95.16-95.13a5.56 5.56 0 0 1 0-7.86l32.95-33a5.56 5.56 0 0 1 7.86 0l136 135.94a5.56 5.56 0 0 1 0 7.86l-136 135.94a5.56 5.56 0 0 1-7.86.05z"
                opacity={1}
                data-original="currentcolor"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
